import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
    production: false,
    apiUrl: 'https://idev.rr.seriousdevelopment.ai/api',
    env: 'dev'
};
